import { createStore } from 'vuex'

import main from './modules/store.main'
import labels from './modules/store.labels'
import search from './modules/store.search'
import dictionary from './modules/store.dictionary'
import events from './modules/store.events'
import fundraising from './modules/store.fundraising'
import donation from './modules/store.donation'
import basket from './modules/store.basket'
import checkout from './modules/store.checkOut'
import forum from './modules/store.forum'
import frivillige from './modules/store.frivillige'
import forms from './modules/store.forms'
import stafet from './modules/store.stafet'
import stafetRoundCounter from './modules/store.stafetRoundCounter'
import frivilligprofil from './modules/store.frivilligprofil'
import lottery from './modules/store.lottery'
import mitid from './modules/store.mitid'
import frivilligjob from './modules/store.frivilligjob'

const store = createStore({
    modules: {
        labels,
        main,
        search,
        dictionary,
        events,
        fundraising,
        donation,
        basket,
        checkout,
        forum,
        frivillige,
        forms,
        stafet,
        stafetRoundCounter,
        frivilligprofil,
        lottery,
        mitid,
        frivilligjob
    }
})

export default store
